import { useMemo } from "react";
import { getAttributeWithValues, getAvailableItems } from "../../../../components/StoreLocator/utils/detailPageHelpers";
const TOBACCONIST_AND_VENDING_MACHINE = "Tobacconist with Vending Machine";
export const useStoreVisibility = (storeDetails) => {
    return useMemo(() => {
        const store = storeDetails?.store;
        const productAttributes = {
            productTypes: getAttributeWithValues(store?.product_attributes, "ProductTypes"),
            productFlavours: getAttributeWithValues(store?.product_attributes, "ProductFlavours"),
            productFlavoursVendingMachine: getAttributeWithValues(store?.product_attributes_vending_machine, "ProductFlavoursVendingMachine"),
        };
        const availableProducts = getAvailableItems(store?.product_types, "is_available");
        const availableProductsVendingMachine = getAvailableItems(store?.product_types_vending_machine, "is_available");
        const availableServices = getAvailableItems(store?.services, "is_available");
        const visibility = {
            isOpeningHoursVisible: Boolean(storeDetails?.isOpeningHoursEnabled && !!store?.opening_hours?.length),
            isStoreTypeVisible: Boolean(storeDetails?.isStoreTypeEnabled && !!store?.storetype),
            isGeneralAnnouncementVisible: Boolean(storeDetails?.isGeneralAnnouncementEnabled && !!store?.opening_hours?.[0]?.general_announcement?.length),
            isAvailableServicesVisible: storeDetails?.isAvailableServicesEnabled && availableServices.length > 0,
            isAvailableProductsVisible: storeDetails?.isAvailableDevicesEnabled && availableProducts.length > 0,
            isAvailableSticksVisible: Boolean(storeDetails?.isAvailableSticksEnabled && !!productAttributes.productFlavours?.values?.length),
            isVendingMachineVisible: storeDetails?.isVendingMachineEnabled &&
                store?.storetype === TOBACCONIST_AND_VENDING_MACHINE &&
                (!!productAttributes.productFlavoursVendingMachine?.values?.length ||
                    availableProductsVendingMachine.length > 0),
        };
        return {
            visibility,
            processedData: {
                availableProducts,
                availableProductsVendingMachine,
                productAttributes,
                availableServices,
            },
        };
    }, [storeDetails]);
};
//# sourceMappingURL=useStoreVisibility.js.map